// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bi-2";
export var aiChatCartContainerExit = "_bi-4";
export var aiChatContainerLarge = "_bi-0";
export var aiChatContainerSmall = "_bi-1";
export var aiChatIcon = "_bi-6";
export var slideInFromRight = "_bi-3";
export var slideOutToRight = "_bi-5";